
















import Vue from "vue";

export default Vue.extend({
  name: "TypingInput",
  props: {
    answer: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.$nextTick(() => {
      (this.$refs.input as HTMLInputElement).focus();
    });
  },
  watch: {
    disabled: {
      handler(isDisabled) {
        if (!isDisabled) {
          this.$nextTick(() => {
            (this.$refs.input as HTMLInputElement).focus();
          });
        }
      }
    }
  }
});
